import React, { useState, useEffect, useMemo } from 'react';
import Navbar from '../navbar/Navbar';
import classNames from 'classnames';
import styles from './style.module.scss';
import { mainNavigationUser, checkPathConstaint, mainNavigationAdmin } from './Constant';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { adminEnum, roleEnum } from 'shared/utils/Enum';
import LimitedAccess from 'shared/modal/limited_access/LimitedAccess';
import { resetRestrictScreen } from 'shared/redux/reducers/restrictScreenSlice';
import BrandLogo from 'shared/components/brand_logo/BrandLogo';

export default function DashboardWrapper({ children }) {
    const dispatch = useDispatch();
    const location = useLocation();
    let locPath = location.pathname;
    const {
        theme: { theme },
        user,
        limitedAccessScreen,
        routePermission: { RoutelistPath }
    } = useSelector((state) => state.root);
    const [showSidebar, setShowSidebar] = useState(false);
    const [permissionRoute, setPermissionRoute] = useState(mainNavigationAdmin);
    const navigate = useNavigate();
    const navigateToPath = (path) => {
        navigate(path);
    };
    console.log(permissionRoute, "permissionRoute");


    const handleClick = (e) => {
        const elem = document.getElementById('SidebarContainer');
        const NavbarElem = document.getElementById('Navbar');
        if (elem) {
            if (!NavbarElem?.contains(e.target)) {
                setShowSidebar?.(false);
            } else if (!NavbarElem?.contains(e.target) && !elem?.contains(e.target)) {
                setShowSidebar?.(false);
            }
        }
    };

    useEffect(() => {
        document.body.addEventListener(
            'click',
            (event) => {
                handleClick(event);
            },
            true
        );

        return () => {
            document.body.removeEventListener(
                'keydown',
                (event) => {
                    handleClick(event);
                },
                true
            );
        };
    }, []);
    useEffect(() => {
        const userRole = user?.user?.role;
        // Super Admin gets full sidebar access
        if (userRole?.name === adminEnum.superAdmin) {
            setPermissionRoute(mainNavigationAdmin);
            return;
        }

        let list = [...RoutelistPath];
        if (userRole) {
            Object.entries(userRole).forEach(([key, value]) => {
                if (value?.view || value?.create || value?.update || value?.delete) {
                    list.push(key);
                }
            });
        }
        list = [...new Set(list)];

        // Select the base navigation list
        const baseNav = user?.user?.authorize === roleEnum.admin ? mainNavigationAdmin : mainNavigationAdmin;
        // Note: if user side has different base list, use that. 
        // But user said they want to see what is allowed, so likely same modules.

        let permissionRouteList = baseNav.filter((ii) => {
            if (ii) {
                // Extracts the root path segment, e.g., 'po' from '/po/list'
                const pathKey = ii.path.split('/')[1] || ii.path.split('/')[2];
                return list.includes(pathKey);
            }
            return false;
        });
        setPermissionRoute(permissionRouteList);
    }, [RoutelistPath, user?.user?.role, user?.user?.authorize]);

    const activePathHandler = () => {
        const pathSegments = locPath.split('/');
        return `/${pathSegments[1]}`;
    };
    const closeLimitedAccess = () => {
        dispatch(resetRestrictScreen());
    };

    return (
        <>
            <Navbar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <div className="d-flex">
                <div id="SidebarContainer" className={classNames(styles.SidebarContainer, showSidebar && styles.SidebarExpand, `${theme}ModeBorderRightNone`)}>
                    <div className={styles.LogoWrapper}>
                        <BrandLogo brandStyle={styles.SidebarLogo} themeClass={theme} />
                    </div>
                    <div className={classNames('text-start', styles.MainNavigation)}>
                        {permissionRoute.map((item, inx) => {
                            return (
                                <a
                                    href={item.path}
                                    className={classNames(styles.NaivgationItem)}
                                    key={`sidebar-item-${inx}`}
                                    style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                                    onClick={(e) => {
                                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                                        e.preventDefault();
                                        navigateToPath(item.path);
                                    }}
                                >
                                    {item?.img ? (
                                        <img src={item.Icon} className={classNames(styles.NavigIcon, item.path?.includes(activePathHandler()) ? styles.ActiveIcon : '', `${theme}SvgIcon`)} />
                                    ) : (
                                        <item.Icon className={classNames(styles.NavigIcon, item.path?.includes(activePathHandler()) ? styles.ActiveIcon : '', `${theme}SvgIcon`)} />
                                    )}
                                    <span
                                        className={classNames(
                                            styles.NavigText,
                                            showSidebar && styles.ShowText,
                                            item.path?.includes(activePathHandler()) ? styles.ActiveText : ''
                                        )}
                                    >
                                        {item.text}
                                    </span>
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className={classNames(styles.Content, `${theme}WhiteBg`)}>{children}</div>
                <LimitedAccess show={limitedAccessScreen.restrictScreen} handleClose={closeLimitedAccess} />
            </div>
        </>
    );
}
